import { Api } from '@/interface/api';

/**
 * 获取活动列表
 */
const getConfig: Api = {
    url: '/api/config/v1/sso',
    method: 'get',
};

export { getConfig };
